export default __webpack_public_path__ + "static/media/ic_crop_img.21a48736.svg";